<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новая группа контактов',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новая группа контактов',
			items: [],
            category_uuid: '',
            trackBy: 'id',
            name: '',
            code: '',
            comments: '',
            category: null,
            initCategory: [],
            category_options: [],
		}
	},

    watch: {
        initCategory: {
            immediate: true,
            handler(values) {
                this.category = this.category_options.filter(x => values.includes(x[this.trackBy]));
                this.category = this.category[0];
            }
        }
    },

	computed: {
        categories_item(){
            let category = this.$store.getters['contactsCategories/GET_CONTACTS_CATEGORIES_ITEM'];
            return category;
        },
        contacts_categories_list_data(){
            return this.$store.getters['contactsCategories/GET_CONTACTS_CATEGORIES_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
	},

	async mounted() {

        this.category_uuid = this.$route.params.category_uuid ? this.$route.params.category_uuid : '';

        await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_LIST', {'sortBy': 'id', 'sortDesc': 'DESC'});
        this.category_options = this.contacts_categories_list_data;

        if(this.category_uuid !== ''){

            this.title = 'Редактирование группы контактов';
            document.title = appConfig.title + ' - ' + 'Редактирование группы контактов';

            let data_send = {
                'uuid' : this.category_uuid,
            }

            await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_ITEM', data_send);

            let category = this.categories_item;

            this.name   = category.name ? category.name : null;
            this.comments = category.comments ? category.comments : null;
            this.code   = category.code ? category.code : null;
            this.category = category.parent_id ? category.parent_id : null;

            if (this.category !== null) {
                this.initCategory = [this.category];
            }
        }
	},

	methods: {

        async saveItem(){

            let data_send = {
                'name'      : this.name ? this.name : null,
                'code'      : this.code ? this.code : null,
                'comments'  : this.comments ? this.comments : null,
                'parent_id' : this.category && this.category.id ? this.category.id : null,
            };

            let result = '';

            if(this.category_uuid === ''){
                result = await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_CREATE', data_send);
            } else {
                data_send.uuid = this.category_uuid;
                result = await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Contacts.Categories'});
            }
        }
	}
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Код"
                                        label-for="input-horizontal"
                                    >
                                        <b-form-input
                                            id="code"
                                            v-model="code"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Название"
                                        label-for="input-horizontal"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Комментарий"
                                        label-for="input-horizontal"
                                    >
                                        <b-form-input
                                            id="comments"
                                            v-model="comments"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
